


export type FormCompletion = 'InComplete' | 'Completed';

export const FormCompletion = {
    InComplete: 'InComplete' as FormCompletion,
    Completed: 'Completed' as FormCompletion
};

